import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FilterSection from './FilterSection';
import { getCurrentNode } from '../../reducers/nav/selectors';
import { nodeSelected } from '../../reducers/nav/actions';
import { GetRegion } from '../../constants';
import HTMLDECODE from '../../utils/htmlDecode';

import './filters-container.scss';

class FiltersContainer extends Component {
  constructor(props) {
    super(props);
    this.handleChangeCategory = this.handleChangeCategory.bind(this);
    this.handleChangePriority = this.handleChangePriority.bind(this);
    this.state = {
      textPrioritySelect: props.ordenamiento && props.ordenamiento[0].label,
    };
  }

  handleChangeCategory(event, opt) {
    const route = `/${GetRegion()}/${opt.code}`;
    if (this.props.onChangeCategoryOpt) {
      this.props.onChangeCategoryOpt(opt);
    }
    this.props.navigate(route);
    this.props.nodeSelected(opt.code);
  }

  handleChangePriority(event, opt) {
    if (this.props.onChangePriorityOpt) {
      this.props.onChangePriorityOpt(event, opt);
    }
    this.setState({
      textPrioritySelect: opt.label,
    });
  }

  render() {
    const filtersProps = [];
    const { onToggleMenu = () => {}, node, ordenamiento = [] } = this.props;
    const textPrioritySelect = this.state.textPrioritySelect;
    let appBehavior;
    try {
      appBehavior = JSON.parse(node.app_behaviour);
    } catch (err) {
      console.warn(err);
    }
    if (appBehavior && appBehavior.layout === 'filterbygenre') {
      let textSelect = node.label || node.text;
      if (node.parent !== null) {
        textSelect = node.label || node.text;
        filtersProps.push({
          onToggleMenu,
          handleChange: this.handleChangeCategory,
          ordenamiento: node.parent.childs,
          textSelect: textSelect || 'Selecciona una categoria',
          id: 'category',
          key: 'category',
        });

        filtersProps.push({
          onToggleMenu,
          handleChange: this.handleChangePriority,
          ordenamiento,
          textSelect: HTMLDECODE(textPrioritySelect) || 'Selecciona un filtro',
          id: 'priority',
          key: 'priority',
        });
      } else {
        filtersProps.push({
          onToggleMenu,
          handleChange: this.handleChangeCategory,
          ordenamiento: node.childs,
          textSelect: 'Filtro por género',
          id: 'category',
          key: 'category',
        });
      }
      const classLabel = filtersProps.length > 1 ? 'db-filter-label' : '';

      return (
        <div>
          <div className="filters-container">
            <div>
              {filtersProps.length > 0 &&
                filtersProps.map(filter => <FilterSection {...filter} />)}
            </div>
          </div>
          <div className={`filter-label  ${classLabel}`}>{textSelect}</div>
        </div>
      );
      // TODO: this functionality should be remove when the app_behaviour key aplly to all regions.
    }
    if (ordenamiento && ordenamiento.length) {
      filtersProps.push({
        onToggleMenu,
        handleChange: this.handleChangePriority,
        ordenamiento,
        textSelect: HTMLDECODE(textPrioritySelect) || 'Selecciona un filtro',
        id: 'priority',
        key: 'priority',
      });

      return (
        <div className="filters-container">
          {filtersProps.map(filter => (
            <FilterSection {...filter} />
          ))}
        </div>
      );
    }

    return null;
  }
}

FiltersContainer.propTypes = {
  node: PropTypes.object.isRequired,
  nodeSelected: PropTypes.func,
  onToggleMenu: PropTypes.func,
  onChangeCategoryOpt: PropTypes.func,
  onChangePriorityOpt: PropTypes.func,
  textsDefault: PropTypes.array,
  ordenamiento: PropTypes.array,
};

const mapStateToProps = state => ({
  node: getCurrentNode(state),
});

const mapDispatchToProps = dispatch => ({
  nodeSelected: node => dispatch(nodeSelected(node)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FiltersContainer);
